export default "__VITE_ASSET__VmTSkxN7__"